import styles from "../../styles/input.module.scss";

import classNames from "classnames/bind";

export const Textarea = ({
  design = "one",
  placeholder = " ",
  onBlur,
  onFocus,
  autoFocus,
  onChange,
  onKeyDown,
  label,
  resizeVertical,
  floatLabel,
  className = "",
  defaultValue,
  minHeight = 150,
  maxLength,
  ...props
}) => {
  const cx = classNames.bind(styles);

  const { name, readOnly, value } = props;
  const id = props.id || name;

  return (
    <div className={`${styles.inputContainer} ${className}`}>
      <textarea
        id={id}
        name={name}
        placeholder={placeholder}
        onChange={onChange}
        onKeyDown={onKeyDown}
        onBlur={onBlur}
        onFocus={onFocus}
        autoFocus={autoFocus}
        defaultValue={defaultValue}
        style={{
          resize: resizeVertical ? "vertical" : "none",
          minHeight: minHeight,
        }}
        maxLength={maxLength}
        readOnly={readOnly}
        value={value}
        className={cx({
          [`design-${design}`]: true,
        })}
      />
      {label && (
        <label className={styles.label} htmlFor={name}>
          {label}
        </label>
      )}
      {floatLabel && <label className={styles.float}>{floatLabel}</label>}
    </div>
  );
};
